
import { KamService } from "@/api";
import { KAM_FETCH } from "@/store/actions.type";
import { FETCH_START, FETCH_END, SET_KAM } from "@/store/mutations.type";

const state = () => ({
    isLoading: false,
    kams: [],
});

const actions = {

    async [KAM_FETCH]({ commit, state }) {

        if (!!state.kams.length) {
            return state.kams;
        }

        commit(FETCH_START);

        try {
            const { data } = await KamService.get();
            commit(SET_KAM, data.data);

            return data;

        } catch(e) {
            commit(FETCH_END);
        }

        return null;
    },
};

const mutations = {

    [FETCH_START](state) {
        state.isLoading = true;
    },

    [FETCH_END](state) {
        state.isLoading = false;
    },

    [SET_KAM](state, data) {

        state.isLoading = false;
        state.kams = [
            ...data
        ];
    },
};

const getters = {
    isLoading: (state) => {
        return state.isLoading;
    },

    getKams: (state) => {
        return state.kams;
    },

    getKamDetails: (state) => (kamEmail) => {

        if (!state.kams) {
            return null;
        }

        return state.kams.find((kam) => kam.email == kamEmail);
    },
};


export const kam = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
